
define('ldsh!modules/editor/templates/elements/form_amp', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (customAMPScript.url) { ;
__p += '\n  <amp-script layout="container" src="' +
((__t = ( customAMPScript.url )) == null ? '' : __t) +
'">\n';
 } else if (customAMPScript.content) { ;
__p += '\n  <amp-script layout="container" script="lpg-form-script">\n';
 } ;
__p += '\n\n<form\n  id="lpg-form"\n  name="lpg-form-main"\n  method="post"\n  action-xhr="' +
((__t = ( confirmationUrl )) == null ? '' : __t) +
'"\n  verify-xhr="{{verifyFormAMPHost}}' +
((__t = ( verifyUrl )) == null ? '' : __t) +
'"\n  custom-validation-reporting="' +
((__t = ( formValidationReporting )) == null ? '' : __t) +
'"\n  target="_top">\n\n  ';
 if (externalConfirmationUrl) {;
__p += '\n  <input type="hidden" name="__external_confirmation_url__" value="' +
((__t = ( externalConfirmationUrl )) == null ? '' : __t) +
'" />\n  ';
};
__p += '\n\n  ';
 if (skipConversion) {;
__p += '\n  <input type="hidden" name="__skipconversion__" id="__skipconversion__" value="true" />\n  ';
};
__p += '\n\n  ';
 if (reqConversion) {;
__p += '\n  <input type="hidden" name="__reqconversion__" id="__reqconversion_" value="' +
((__t = ( reqConversion )) == null ? '' : __t) +
'" />\n  ';
};
__p += '\n\n  ';
 if (successMessage) {;
__p += '\n  <input type="hidden" name="__successmessage__" id="__successmessage_" value="' +
((__t = ( escapedSuccessMessage )) == null ? '' : __t) +
'" />\n  ';
};
__p += '\n\n  ';
 if (isSingleStep || executionStep) {;
__p += '\n  <input type="hidden" name="__exec_conversion__" id="__exec_conversion__" value="true" />\n  ';
};
__p += '\n\n  <input type="hidden" name="__variants_id" id="__variants_id" value="' +
((__t = ( variantId )) == null ? '' : __t) +
'" />\n  <input type="hidden" name="__confirmation_sendparams__" value="' +
((__t = ( confirmationSendParams )) == null ? '' : __t) +
'" />\n  <input type="hidden" name="__hash__" id="__hash__" value="{{hash}}" />\n  <input type="hidden" name="variants_id" value="{{variants_id}}" />\n  <input type="hidden" name="visits_id" value="" />\n  <input type="hidden" name="pages_id" value="{{pages_id}}" />\n\n  <div class="js-fields"></div>\n\n  <div id="extra-amp-errors" hidden></div>\n\n  <div class="editor-form-group form-group form-group-col one-whole">\n    <div class="col-sm-12 js-control js-submit-wrapper">\n      <button\n          id="submit"\n          type="submit"\n          class="btn btn-default js-submit"\n          form="lpg-form"\n          disabled [disabled]="disable"\n          on="tap:AMP.setState({disable: true})"\n      ></button>\n    </div>\n  </div>\n\n  <div class="hidden-no-amp form-validation-overlay" submit-error>\n    <h2 data-i18n="common.formError_es"></h2>\n    <template type="amp-mustache">\n      {{#verifyErrors}}\n      <ul>\n        <li>{{message}}</li>\n      </ul>\n      {{/verifyErrors}}\n      {{^verifyErrors}}\n      <p data-i18n="common.formError_general"></p>\n      {{/verifyErrors}}\n    </template>\n  </div>\n</form>\n\n\n';
 if (customAMPScript.url || customAMPScript.content) { ;
__p += '\n  </amp-script>\n';
 } ;
__p += '\n\n';
 if (customAMPScript.content) { ;
__p += '\n    <script id="lpg-form-script" type="text/plain" target="amp-script">' +
((__t = ( customAMPScript.content )) == null ? '' : __t) +
'</script>\n';
 } ;
__p += '\n';

}
return __p
};});

